import { ReactElement } from "react";
import { IconWithTooltip, labelToDataId, TooltipType } from "@flexidao/ui-lib";
import { Group, Text } from "@mantine/core";
import { DEFAULT_HEADER_FONT_SIZE_PX, GROUPED_HEADER_FONT_SIZE_PX } from "./consts";

type HeaderWithTooltipProps = {
    title: string;
    tooltip?: TooltipType;
    headerGroup?: string;
};

export const HeaderWithTooltip = ({
    title,
    tooltip,
    headerGroup,
}: HeaderWithTooltipProps): ReactElement => {
    const isGrouped = headerGroup !== undefined;
    const fontSize = isGrouped ? GROUPED_HEADER_FONT_SIZE_PX : DEFAULT_HEADER_FONT_SIZE_PX;

    return (
        <Group
            noWrap
            align="center"
            spacing={2}
            data-id={labelToDataId({
                prefix: headerGroup,
                label: title,
                suffix: "header" + (tooltip ? "--with-tooltip" : ""),
            })}
        >
            {tooltip && (
                <IconWithTooltip
                    tooltip={tooltip}
                    dataId={labelToDataId({
                        prefix: headerGroup,
                        label: title,
                        suffix: "tooltip",
                    })}
                />
            )}

            <Text size={fontSize} weight={500}>
                {title}
            </Text>
        </Group>
    );
};
